import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const columnLables = {
  rehypothecation_flag: {
    name: 'Do the contracts the reporting fund has posted to counterparties allow them to re-hypothecate collateral and other credit support?',
    order: 223,
    letter: 'A'
  },
  rehypothecated_rate: {
    name: 'Of the amount of collateral and other credit support that the reporting fund has posted to counterparties: what percentage has been re-hypothecated by those counterparties?',
    order: 224,
    letter: 'A'
  }
};

export function FinancingLiquidity3({
  onChangeFund,
  funds,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.FINANCING_PROFILE,
    onChangeFund,
    schema: schema.FINANCING_PROFILE,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.FINANCING_PROFILE?.field_names || [],
    columnLables,
    tableName: 'FINANCING_PROFILE',
    isMultiFunds,
    funds
  });

  return (
    <Table
      id="fca-reporttables-financing-liquidity-3-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
